/** to get dynamic variables from kube to static react app build, we need to place variables from config.js file to window.X.
 * This file only exists if server.js is running so we need fallback to normal process.env variables on local **/
import { config as dotenvConfig } from 'dotenv';

dotenvConfig();

const config = {
  appVersion:
    import.meta.env.__PACKAGE_JSON_VERSION__ ||
    window?.__PACKAGE_JSON_VERSION__ ||
    process.env.__PACKAGE_JSON_VERSION__,
  dotEnvFilenameVar:
    import.meta.env.DOTENV_FILENAME_VAR || process.env.DOTENV_FILENAME_VAR,
  buildId: import.meta.env.CI_PIPELINE_ID || process.env.CI_PIPELINE_ID,
  graphqlUrl:
    import.meta.env.VITE_GRAPHQL_URL ||
    process.env.VITE_GRAPHQL_URL ||
    window?.VITE_GRAPHQL_URL,
  reactiveVarPrefix: '@aimodevRV_',
  siteName:
    import.meta.env.VITE_SITE_NAME ||
    process.env.VITE_SITE_NAME ||
    window?.VITE_SITE_NAME,
  devScreen: process.env.DOTENV_FILENAME_VAR === 'env' ? 'true' : 'false',
  isE2ETest:
    import.meta.env.VITE_IS_E2E_TEST ||
    process.env.VITE_IS_E2E_TEST ||
    window?.VITE_IS_E2E_TEST,
  VITE_AZURE_DOMAIN:
    import.meta.env.VITE_AZURE_DOMAIN ||
    process.env.VITE_AZURE_DOMAIN ||
    window?.VITE_AZURE_DOMAIN,
  VITE_AZURE_CLIENT_ID:
    import.meta.env.VITE_AZURE_CLIENT_ID ||
    process.env.VITE_AZURE_CLIENT_ID ||
    window?.VITE_AZURE_CLIENT_ID,
  VITE_SUSI_FLOW:
    import.meta.env.VITE_SUSI_FLOW ||
    process.env.VITE_SUSI_FLOW ||
    window?.VITE_SUSI_FLOW,
  VITE_SUSI_TEST_FLOW:
    import.meta.env.VITE_SUSI_TEST_FLOW ||
    process.env.VITE_SUSI_TEST_FLOW ||
    window?.VITE_SUSI_TEST_FLOW,
  PRIVACY_POLICY_URL:
    import.meta.env.PRIVACY_POLICY_URL ||
    process.env.PRIVACY_POLICY_URL ||
    window?.PRIVACY_POLICY_URL,
  TERMS_AND_CONDITIONS_URL:
    import.meta.env.TERMS_AND_CONDITIONS_URL ||
    process.env.TERMS_AND_CONDITIONS_URL ||
    window?.TERMS_AND_CONDITIONS_URL,
  VITE_UPPSALA_SERVICE:
    import.meta.env.VITE_UPPSALA_SERVICE ||
    process.env.VITE_UPPSALA_SERVICE ||
    window?.VITE_UPPSALA_SERVICE,
  VITE_HTTP_BACKEND_TRANSLATIONS_URL:
    import.meta.env.VITE_HTTP_BACKEND_TRANSLATIONS_URL ||
    process.env.VITE_HTTP_BACKEND_TRANSLATIONS_URL ||
    window?.VITE_HTTP_BACKEND_TRANSLATIONS_URL,
  googleMapsApiKey:
    window?.GOOGLE_MAPS_API_KEY ||
    process.env.GOOGLE_MAPS_API_KEY ||
    import.meta.env.GOOGLE_MAPS_API_KEY,
  serviceChannelCode:
    import.meta.env.SERVICE_CHANNEL_CODE ||
    process.env.SERVICE_CHANNEL_CODE ||
    window?.SERVICE_CHANNEL_CODE,
  clarityProjectId:
    import.meta.env.VITE_CLARITY_PROJECT_ID_WEB ||
    process.env.VITE_CLARITY_PROJECT_ID_WEB ||
    window?.VITE_CLARITY_PROJECT_ID_WEB,
  redirectUriWeb:
    import.meta.env.VITE_REDIRECT_URI_WEB ||
    process.env.VITE_REDIRECT_URI_WEB ||
    window?.VITE_REDIRECT_URI_WEB,
  featureFlagsDefault: {
    account_contact_edit:
      import.meta.env.VITE_FIREBASE_REMOTE_CONFIG_ACCOUNT_CONTACT_EDIT ||
      process.env.VITE_FIREBASE_REMOTE_CONFIG_ACCOUNT_CONTACT_EDIT ||
      window?.VITE_FIREBASE_REMOTE_CONFIG_ACCOUNT_CONTACT_EDIT,
    account_contact_invoice_email:
      import.meta.env
        .VITE_FIREBASE_REMOTE_CONFIG_ACCOUNT_CONTACT_INVOICE_EMAIL ||
      process.env.VITE_FIREBASE_REMOTE_CONFIG_ACCOUNT_CONTACT_INVOICE_EMAIL ||
      window?.VITE_FIREBASE_REMOTE_CONFIG_ACCOUNT_CONTACT_INVOICE_EMAIL,
    account_contact_phone_number:
      import.meta.env
        .VITE_FIREBASE_REMOTE_CONFIG_ACCOUNT_CONTACT_PHONE_NUMBER ||
      process.env.VITE_FIREBASE_REMOTE_CONFIG_ACCOUNT_CONTACT_PHONE_NUMBER ||
      window?.VITE_FIREBASE_REMOTE_CONFIG_ACCOUNT_CONTACT_PHONE_NUMBER,
    account_history_permit_parking_space:
      window.VITE_FIREBASE_REMOTE_CONFIG_ACCOUNT_HISTORY_PERMIT_PARKING_SPACE ||
      process.env
        .VITE_FIREBASE_REMOTE_CONFIG_ACCOUNT_HISTORY_PERMIT_PARKING_SPACE,
    account_notification_settings:
      import.meta.env
        .VITE_FIREBASE_REMOTE_CONFIG_ACCOUNT_NOTIFICATION_SETTINGS ||
      process.env.VITE_FIREBASE_REMOTE_CONFIG_ACCOUNT_NOTIFICATION_SETTINGS ||
      window?.VITE_FIREBASE_REMOTE_CONFIG_ACCOUNT_NOTIFICATION_SETTINGS,
    account_notification_settings_parking_ending_reminders:
      import.meta.env
        .VITE_FIREBASE_REMOTE_CONFIG_ACCOUNT_NOTIFICATION_SETTINGS_PARKING_ENDING_REMINDERS ||
      process.env
        .VITE_FIREBASE_REMOTE_CONFIG_ACCOUNT_NOTIFICATION_SETTINGS_PARKING_ENDING_REMINDERS ||
      window?.VITE_FIREBASE_REMOTE_CONFIG_ACCOUNT_NOTIFICATION_SETTINGS_PARKING_ENDING_REMINDERS,
    account_payment_ca_as_default_toggle_display:
      import.meta.env
        .VITE_FIREBASE_REMOTE_CONFIG_ACCOUNT_PAYMENT_AS_DEFAULT_TOGGLE_DISPLAY ||
      process.env
        .VITE_FIREBASE_REMOTE_CONFIG_ACCOUNT_PAYMENT_AS_DEFAULT_TOGGLE_DISPLAY ||
      window?.VITE_FIREBASE_REMOTE_CONFIG_ACCOUNT_PAYMENT_AS_DEFAULT_TOGGLE_DISPLAY,
    account_rides:
      import.meta.env.VITE_FIREBASE_REMOTE_CONFIG_ACCOUNT_RIDE ||
      process.env.VITE_FIREBASE_REMOTE_CONFIG_ACCOUNT_RIDE ||
      window?.VITE_FIREBASE_REMOTE_CONFIG_ACCOUNT_RIDE,
    anpr:
      import.meta.env.VITE_FIREBASE_REMOTE_CONFIG_ANPR ||
      process.env.VITE_FIREBASE_REMOTE_CONFIG_ANPR ||
      window?.VITE_FIREBASE_REMOTE_CONFIG_ANPR,
    app_version_mandatory:
      import.meta.env.VITE_FIREBASE_REMOTE_CONFIG_APP_VERSION_MANDATORY ||
      process.env.VITE_FIREBASE_REMOTE_CONFIG_APP_VERSION_MANDATORY ||
      window?.VITE_FIREBASE_REMOTE_CONFIG_APP_VERSION_MANDATORY,
    app_version_optional:
      import.meta.env.VITE_FIREBASE_REMOTE_CONFIG_APP_VERSION_OPTIONAL ||
      process.env.VITE_FIREBASE_REMOTE_CONFIG_APP_VERSION_OPTIONAL ||
      window?.VITE_FIREBASE_REMOTE_CONFIG_APP_VERSION_OPTIONAL,
    cancel_sales_order:
      import.meta.env.VITE_FIREBASE_REMOTE_CONFIG_CANCEL_SALES_ORDER ||
      process.env.VITE_FIREBASE_REMOTE_CONFIG_CANCEL_SALES_ORDER ||
      window?.VITE_FIREBASE_REMOTE_CONFIG_CANCEL_SALES_ORDER,
    card_business:
      import.meta.env.VITE_FIREBASE_REMOTE_CONFIG_CARD_BUSINESS ||
      process.env.VITE_FIREBASE_REMOTE_CONFIG_CARD_BUSINESS ||
      window?.VITE_FIREBASE_REMOTE_CONFIG_CARD_BUSINESS,
    prepaid_display_valid_from_picker:
      import.meta.env
        .VITE_FIREBASE_REMOTE_CONFIG_PREPAID_DISPLAY_VALID_FROM_PICKER ||
      process.env
        .VITE_FIREBASE_REMOTE_CONFIG_PREPAID_DISPLAY_VALID_FROM_PICKER ||
      window?.VITE_FIREBASE_REMOTE_CONFIG_PREPAID_DISPLAY_VALID_FROM_PICKER,
    company_benefits:
      import.meta.env.VITE_FIREBASE_REMOTE_CONFIG_COMPANY_BENEFITS ||
      process.env.VITE_FIREBASE_REMOTE_CONFIG_COMPANY_BENEFITS ||
      window?.VITE_FIREBASE_REMOTE_CONFIG_COMPANY_BENEFITS,
    hsl_ticket:
      window?.VITE_FIREBASE_REMOTE_CONFIG_HSL_TICKET ||
      process.env.VITE_FIREBASE_REMOTE_CONFIG_HSL_TICKET,
    lang_no:
      import.meta.env.VITE_FIREBASE_REMOTE_CONFIG_LANG_NO ||
      process.env.VITE_FIREBASE_REMOTE_CONFIG_LANG_NO ||
      window?.VITE_FIREBASE_REMOTE_CONFIG_LANG_NO,
    ltp_buy_schedule:
      import.meta.env.VITE_FIREBASE_REMOTE_CONFIG_LTP_BUY_SCHEDULE ||
      process.env.VITE_FIREBASE_REMOTE_CONFIG_LTP_BUY_SCHEDULE ||
      window?.VITE_FIREBASE_REMOTE_CONFIG_LTP_BUY_SCHEDULE,
    park_and_charge_mentions:
      import.meta.env.VITE_FIREBASE_REMOTE_PARK_AND_CHARGE_MENTIONS ||
      process.env.VITE_FIREBASE_REMOTE_PARK_AND_CHARGE_MENTIONS ||
      window?.VITE_FIREBASE_REMOTE_PARK_AND_CHARGE_MENTIONS,
    park_schedule:
      import.meta.env.VITE_FIREBASE_REMOTE_CONFIG_PARK_SCHEDULE ||
      process.env.VITE_FIREBASE_REMOTE_CONFIG_PARK_SCHEDULE ||
      window?.VITE_FIREBASE_REMOTE_CONFIG_PARK_SCHEDULE,
    payment_type_filter:
      import.meta.env.VITE_FIREBASE_REMOTE_PAYMENT_TYPE_FILTER ||
      process.env.VITE_FIREBASE_REMOTE_PAYMENT_TYPE_FILTER ||
      window?.VITE_FIREBASE_REMOTE_PAYMENT_TYPE_FILTER,
    permit_turku:
      import.meta.env.VITE_FIREBASE_REMOTE_CONFIG_PERMIT_TURKU ||
      process.env.VITE_FIREBASE_REMOTE_CONFIG_PERMIT_TURKU ||
      window?.VITE_FIREBASE_REMOTE_CONFIG_PERMIT_TURKU,
    rate:
      import.meta.env.VITE_FIREBASE_REMOTE_CONFIG_RATE ||
      process.env.VITE_FIREBASE_REMOTE_CONFIG_RATE ||
      window?.VITE_FIREBASE_REMOTE_CONFIG_RATE,
    remote_tutorial:
      import.meta.env.VITE_FIREBASE_REMOTE_CONFIG_REMOTE_TUTORIAL ||
      process.env.VITE_FIREBASE_REMOTE_CONFIG_REMOTE_TUTORIAL ||
      window?.VITE_FIREBASE_REMOTE_CONFIG_REMOTE_TUTORIAL,
    retry_payment:
      import.meta.env.VITE_FIREBASE_REMOTE_CONFIG_RETRY_PAYMENT ||
      process.env.VITE_FIREBASE_REMOTE_CONFIG_RETRY_PAYMENT ||
      window?.VITE_FIREBASE_REMOTE_CONFIG_RETRY_PAYMENT,
    ride:
      import.meta.env.VITE_FIREBASE_REMOTE_CONFIG_RIDE ||
      process.env.VITE_FIREBASE_REMOTE_CONFIG_RIDE ||
      window?.VITE_FIREBASE_REMOTE_CONFIG_RIDE,
    sales_order_permits:
      import.meta.env.VITE_FIREBASE_REMOTE_CONFIG_SALES_ORDER_PERMITS ||
      process.env.VITE_FIREBASE_REMOTE_CONFIG_SALES_ORDER_PERMITS ||
      window?.VITE_FIREBASE_REMOTE_CONFIG_SALES_ORDER_PERMITS,
    service_chips:
      import.meta.env.VITE_FIREBASE_REMOTE_CONFIG_SERVICE_CHIPS ||
      process.env.VITE_FIREBASE_REMOTE_CONFIG_SERVICE_CHIPS ||
      window?.VITE_FIREBASE_REMOTE_CONFIG_SERVICE_CHIPS,
    show_norway:
      import.meta.env.VITE_FIREBASE_REMOTE_CONFIG_SHOW_NORWAY ||
      process.env.VITE_FIREBASE_REMOTE_CONFIG_SHOW_NORWAY ||
      window?.VITE_FIREBASE_REMOTE_CONFIG_SHOW_NORWAY,
    show_pooling_spots_refresh_button_delay_milliseconds:
      import.meta.env
        .VITE_FIREBASE_REMOTE_CONFIG_SHOW_POOLING_SPOTS_REFRESH_BUTTON_DELAY_MILLISECONDS ||
      process.env
        .VITE_FIREBASE_REMOTE_CONFIG_SHOW_POOLING_SPOTS_REFRESH_BUTTON_DELAY_MILLISECONDS ||
      window?.VITE_FIREBASE_REMOTE_CONFIG_SHOW_POOLING_SPOTS_REFRESH_BUTTON_DELAY_MILLISECONDS,
    allow_manual_stop_anpr:
      import.meta.env.VITE_FIREBASE_REMOTE_CONFIG_ALLOW_MANUAL_STOP_ANPR ||
      process.env.VITE_FIREBASE_REMOTE_CONFIG_ALLOW_MANUAL_STOP_ANPR ||
      window?.VITE_FIREBASE_REMOTE_CONFIG_ALLOW_MANUAL_STOP_ANPR,
    stp_organisational_user:
      import.meta.env.VITE_FIREBASE_REMOTE_CONFIG_STP_ORGANISATIONAL_USER ||
      process.env.VITE_FIREBASE_REMOTE_CONFIG_STP_ORGANISATIONAL_USER ||
      window?.VITE_FIREBASE_REMOTE_CONFIG_STP_ORGANISATIONAL_USER,
    stp_tariff:
      import.meta.env.VITE_FIREBASE_REMOTE_CONFIG_STP_TARIFF ||
      process.env.VITE_FIREBASE_REMOTE_CONFIG_STP_TARIFF ||
      window?.VITE_FIREBASE_REMOTE_CONFIG_STP_TARIFF,
    show_feedback:
      import.meta.env.VITE_FIREBASE_REMOTE_CONFIG_SHOW_FEEDBACK ||
      process.env.VITE_FIREBASE_REMOTE_CONFIG_SHOW_FEEDBACK ||
      window?.VITE_FIREBASE_REMOTE_CONFIG_SHOW_FEEDBACK,
    time_wheel:
      import.meta.env.VITE_FIREBASE_REMOTE_CONFIG_TIME_WHEEL ||
      process.env.VITE_FIREBASE_REMOTE_CONFIG_TIME_WHEEL ||
      window?.VITE_FIREBASE_REMOTE_CONFIG_TIME_WHEEL,
    time_wheel_config:
      import.meta.env.VITE_FIREBASE_REMOTE_CONFIG_TIME_WHEEL_CONFIG ||
      process.env.VITE_FIREBASE_REMOTE_CONFIG_TIME_WHEEL_CONFIG ||
      window?.VITE_FIREBASE_REMOTE_CONFIG_TIME_WHEEL_CONFIG,
    vehicle_registration_country:
      import.meta.env
        .VITE_FIREBASE_REMOTE_CONFIG_VEHICLE_REGISTRATION_COUNTRY ||
      process.env.VITE_FIREBASE_REMOTE_CONFIG_VEHICLE_REGISTRATION_COUNTRY ||
      window?.VITE_FIREBASE_REMOTE_CONFIG_VEHICLE_REGISTRATION_COUNTRY,
    vehicle_registration_country_edit:
      import.meta.env
        .VITE_FIREBASE_REMOTE_CONFIG_VEHICLE_REGISTRATION_COUNTRY_EDIT ||
      process.env
        .VITE_FIREBASE_REMOTE_CONFIG_VEHICLE_REGISTRATION_COUNTRY_EDIT ||
      window?.VITE_FIREBASE_REMOTE_CONFIG_VEHICLE_REGISTRATION_COUNTRY_EDIT,
    vehicle_type:
      import.meta.env.VITE_FIREBASE_REMOTE_CONFIG_VEHICLE_TYPE ||
      process.env.VITE_FIREBASE_REMOTE_CONFIG_VEHICLE_TYPE ||
      window?.VITE_FIREBASE_REMOTE_CONFIG_VEHICLE_TYPE,
    chatbot_urls:
      import.meta.env.VITE_FIREBASE_REMOTE_CONFIG_CHATBOT_URLS ||
      process.env.VITE_FIREBASE_REMOTE_CONFIG_CHATBOT_URLS ||
      window?.VITE_FIREBASE_REMOTE_CONFIG_CHATBOT_URLS,
    clarity:
      import.meta.env.VITE_FIREBASE_REMOTE_CONFIG_CLARITY ||
      process.env.VITE_FIREBASE_REMOTE_CONFIG_CLARITY ||
      window?.VITE_FIREBASE_REMOTE_CONFIG_CLARITY,
    permit_start_date:
      import.meta.env.VITE_FIREBASE_REMOTE_CONFIG_PERMIT_START_DATE ||
      process.env.VITE_FIREBASE_REMOTE_CONFIG_PERMIT_START_DATE ||
      window?.VITE_FIREBASE_REMOTE_CONFIG_PERMIT_START_DATE,
    dd_rum_enabled:
      import.meta.env.VITE_FIREBASE_REMOTE_CONFIG_DD_RUM_ENABLED ||
      window?.VITE_FIREBASE_REMOTE_CONFIG_DD_RUM_ENABLED,
    dd_session_sampling_rate:
      window.VITE_FIREBASE_REMOTE_CONFIG_DD_SESSION_SAMPLING_RATE ||
      process.env.VITE_FIREBASE_REMOTE_CONFIG_DD_SESSION_SAMPLING_RATE,
    dd_longtask_threshold:
      window.VITE_FIREBASE_REMOTE_CONFIG_DD_LONGTASK_THRESHOLD ||
      process.env.VITE_FIREBASE_REMOTE_CONFIG_DD_LONGTASK_THRESHOLD,
    show_rfid_tag_registration_by_country:
      import.meta.env
        .VITE_FIREBASE_REMOTE_CONFIG_SHOW_RFID_TAG_REGISTRATION_BY_COUNTRY ||
      process.env
        .VITE_FIREBASE_REMOTE_CONFIG_SHOW_RFID_TAG_REGISTRATION_BY_COUNTRY ||
      window?.VITE_FIREBASE_REMOTE_CONFIG_SHOW_RFID_TAG_REGISTRATION_BY_COUNTRY,
    enable_healthcare_permit_button:
      import.meta.env
        .VITE_FIREBASE_REMOTE_CONFIG_ENABLE_HEALTHCARE_PERMIT_BUTTON ||
      process.env.VITE_FIREBASE_REMOTE_CONFIG_ENABLE_HEALTHCARE_PERMIT_BUTTON ||
      window?.VITE_FIREBASE_REMOTE_CONFIG_ENABLE_HEALTHCARE_PERMIT_BUTTON,
    enable_unlock_mg_automatic_pmc_button:
      import.meta.env
        .VITE_FIREBASE_REMOTE_CONFIG_ENABLE_UNLOCK_MG_AUTOMATIC_PMC_BUTTON ||
      process.env
        .VITE_FIREBASE_REMOTE_CONFIG_ENABLE_UNLOCK_MG_AUTOMATIC_PMC_BUTTON ||
      window?.VITE_FIREBASE_REMOTE_CONFIG_ENABLE_UNLOCK_MG_AUTOMATIC_PMC_BUTTON,
    enable_mobilepay_by_country:
      import.meta.env.VITE_FIREBASE_REMOTE_CONFIG_ENABLE_MOBILEPAY_BY_COUNTRY ||
      process.env.VITE_FIREBASE_REMOTE_CONFIG_ENABLE_MOBILEPAY_BY_COUNTRY ||
      window?.VITE_FIREBASE_REMOTE_CONFIG_ENABLE_MOBILEPAY_BY_COUNTRY,
    show_aimo_subscription:
      import.meta.env.VITE_FIREBASE_REMOTE_CONFIG_AIMO_SUBSCRIPTION ||
      process.env.VITE_FIREBASE_REMOTE_CONFIG_AIMO_SUBSCRIPTION ||
      window?.VITE_FIREBASE_REMOTE_CONFIG_AIMO_SUBSCRIPTION,
    subscription_links:
      import.meta.env.VITE_FIREBASE_REMOTE_CONFIG_SUBSCRIPTION_LINKS ||
      process.env.VITE_FIREBASE_REMOTE_CONFIG_SUBSCRIPTION_LINKS ||
      window?.VITE_FIREBASE_REMOTE_CONFIG_SUBSCRIPTION_LINKS,
    enable_adyen_card_add_by_country:
      import.meta.env
        .VITE_FIREBASE_REMOTE_CONFIG_ENABLE_ADYEN_CARD_ADD_BY_COUNTRY ||
      process.env
        .VITE_FIREBASE_REMOTE_CONFIG_ENABLE_ADYEN_CARD_ADD_BY_COUNTRY ||
      globalThis?.VITE_FIREBASE_REMOTE_CONFIG_ENABLE_ADYEN_CARD_ADD_BY_COUNTRY,
  },
};

export default config;
